<template>
    <div class="warpper">
        <div class="page-title">通知公告</div>
        <div class="flex flex-direction">
            <div class="item-notice flex" v-for="(item,index) in lists" :key="index">
                <div class="flex flex-direction justify-between flex-sub overflow-hidden">
                    <div class="title ovHide">{{item.title}}</div>
                    <div class="content ovHide">{{item.content}}</div>
                    <div class="flex align-center">
                        <div class="read" :class="{ed:item.is_read ===1}">{{item.is_read === 0 ? '未读' : '已读'}}</div>
                        <div class="time yellow" :class="{yellow:item.is_read ===1}"  v-if="item.is_need_feedback">
                            {{item.is_feedback === 0 ? '未反馈' : '已反馈'}}
                        </div>
                        <div class="time">{{item.add_time}}</div>
                    </div>
                </div>
                <div class="flex align-center margin-left">
                    <el-button class="operate white" @click="toNoticeDetail(item.id)"><i class="el-icon-view"></i>查看
                    </el-button>
                    <el-button class="operate" :class="{disabled:item.is_feedback}"
                               v-if="item.is_need_feedback" @click="toFeedback(item.id)"><i class="el-icon-chat-dot-square"></i>{{item.is_feedback ? '已反馈' : '反馈'}}
                    </el-button>
                </div>
            </div>
        </div>
        <el-pagination
          v-if="lists.length>0"
                class="page-all margin-top"
                background
                @current-change="init"
                :current-page.sync="page"
                :page-size="limit"
                layout="prev, pager, next, jumper"
                :total="total">
        </el-pagination>
      <el-empty description="暂无数据" v-if="lists.length === 0"></el-empty>
        <notice-detail-dialog :nid="cur_nid" :detailDialogVisible="detailDialogVisible"
                              @watchState="watchState"></notice-detail-dialog>
        <notice-feedback-dialog :nid="cur_nid" :applyDialogVisible="applyDialogVisible"
                                @feedbackState="feedbackState"></notice-feedback-dialog>
    </div>
</template>

<script>
    import {getNoticeList} from '@/api/member'
    import NoticeDetailDialog from "@/components/NoticeDetailDialog.vue";
    import {zhDate} from '@/utils/utils'
    import {reg_html} from '@/utils/rules'
    import NoticeFeedbackDialog from "@/components/NoticeFeedbackDialog.vue";
    export default {
        components: {
            NoticeFeedbackDialog,
            NoticeDetailDialog},
        name: "notice",
        data() {
            return {
                lists: [],
                page: 1,
                limit: 10,
                total: 0,
                cur_nid: 0,
                detailDialogVisible: false,
                applyDialogVisible: false
            }
        },
        created() {
            this.$emit('setIndex', [1], '通知公告')
            this.init()
        },
        computed: {},
        methods: {
            //  页面加载时请求
            async init() {
                let _data = await getNoticeList(this.page, this.limit)
                if (_data.status === 200) {
                    _data.data.map(item => {
                        item.add_time = zhDate(item.add_time * 1000)
                        item.content = item.content.replace(reg_html, '').replace(/&nbsp;/ig, "")
                    })
                    this.lists = _data.data
                    this.total = _data.count
                }
            },
            toNoticeDetail(id) {
                this.cur_nid = id
                this.detailDialogVisible = true;
            },
            watchState(state) {
                if (state){
                    this.init()
                }else {
                    this.detailDialogVisible = false;
                }
            },
            toFeedback(id) {
                this.cur_nid = id
                this.applyDialogVisible = true;
            },
            feedbackState(state) {
                this.applyDialogVisible = false;
                if (state) {
                    this.init()
                }
            },
        }

    }
</script>

<style scoped lang="scss">
    .warpper {
        background-color: #ffffff;
        border-radius: 10px;
        padding: 20px;
        .item-notice {
            width: 100%;
            min-height: 109px;
            background-color: #f3f7fb;
            border-radius: 10px;
            margin-top: 20px;
            padding: 11px 20px;
            .title {
                font-size: 20px;
                font-weight: bold;
                color: #0a2240;
            }
            .content {
                width: 100%;
                font-size: 14px;
                color: #7889a4;
            }
            .read {
                width: 39px;
                height: 16px;
                line-height: 16px;
                text-align: center;
                background-color: #ff9600;
                border-radius: 8px;
                font-size: 12px;
                margin-right: 8px;
                color: #ffffff;
                .ed {
                    background-color: #8ba2c6;
                }
            }
            .time {
                font-size: 14px;
                color: #7889a4;
                margin-right: 8px;
                &.yellow {
                    color: #ff9600;
                }
            }
            .operate {
                width: 99px;
                height: 40px;
                border-radius: 20px;
                font-size: 16px;
                background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                linear-gradient(#ff9600, #ff9600);
                background-blend-mode: normal, normal;
                color: #ffffff;
                &.white {
                    background: #ffffff none;
                    color: #ff9600;
                }
                &.disabled {
                    background: #b4c7e5 none;
                }
            }
        }
    }

</style>